module.exports = __webpack_public_path__ + "static/media/400055_02.a468d14c.png";